import PrerenderManager from 'helpers/prerenderManager/prerenderManager';
import { useEffect, useState } from 'react';

export const usePrerenderComponentReady = ({
    hasDoneRendering,
    componentName,
}: {
    hasDoneRendering: boolean;
    componentName: string;
}) => {
    const [hasInformPrerenderingManager, setHasInformPrerenderingManager] =
        useState(false);

    useEffect(() => {
        if (
            PrerenderManager &&
            hasDoneRendering &&
            !hasInformPrerenderingManager
        ) {
            setHasInformPrerenderingManager(true);
            PrerenderManager.componentDoneRendering(componentName);
        }
    }, [hasDoneRendering, hasInformPrerenderingManager, componentName]);
};
